<script setup>
  import { ref, useAttrs } from 'vue';

  const props = defineProps({
    iconPosition: { type: String, default: 'left' },
    placeholder:  { type: String, default: null },
    prefix:       { type: String, default: '$ ' },
    suffix:       { type: String, default: null },
    size:         { type: String, default: 'small' },
    minDigits:    { type: Number, default: 2 },
    maxDigits:    { type: Number, default: 2 },
  })

  const model = defineModel()
  const attrs = useAttrs()
  const emit  = defineEmits(['update:modelValue'])
</script>

<template lang="pug">
  InputNumber(
    v-model="model"
    v-bind="attrs"
    :placeholder="placeholder"
    :minFractionDigits="minDigits"
    :maxFractionDigits="maxDigits"
    :prefix="prefix"
    :suffix="suffix"
    :size="size"
    locale="en-US"
    :inputClass="attrs.class"
    :step="$attrs.step || 0.01"
  )
  //- :highlightOnFocus="true"
  //- :showClear="true"
  //- pre props: {{props}}
  //- pre attrs: {{attrs}}
</template>